<div class="v3">
    <mat-expansion-panel #panel class="v3" [ngClass]="{'hideBorder': hideBorder, 'background-base-50': hasBackground, 'padding-8': !hasHeaderBottomBorder && hasHorizontalPadding, 'padding-y-8': !hasHorizontalPadding }"
        [attr.data-sb-qa]="qaTag"
        (closed)="TogglePanel(panel.expanded)"
        (opened)="TogglePanel(panel.expanded)">
        <mat-expansion-panel-header
            [expandedHeight]="'auto'"
            [collapsedHeight]="'auto'"
            [ngClass]="{'scss-expansion-panel-header-bottom-border': hasHeaderBottomBorder }">
            <div class="w-100" [ngClass]="{'p-2': hasHeaderPadding && hasHorizontalPadding, 'padding-y-2': hasHeaderPadding && !hasHorizontalPadding}">
                <div class="d-flex align-items-baseline scss-info-card-header">
                    <ng-content select="[header]">
                    </ng-content>
                </div>
                <ng-content select="[subheader]"></ng-content>
            </div>
        </mat-expansion-panel-header>
        <div class="w-100 pb-2" [ngClass]="{'padding-x-8': hasHorizontalPadding}">
            <ng-content select="[body]"></ng-content>
        </div>
    </mat-expansion-panel>
</div>
